import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { initializeApp } from "firebase/app";

// Componentes
import AboutMe from "./components/principals/AboutMe";
import Home from "./components/principals/Home";
import Contact from "./components/principals/Contact";
import Navbar from "./components/principals/Navbar";
import Services from "./components/principals/Services";
//import Portfolio from "./components/principals/Portfolio";
import Booking from "./components/principals/Booking";
import Blog from "./components/principals/Blog/Blog";
import BlogArticle from "./components/principals/Blog/BlogArticle";
import Login from "./components/principals/login/Login";
import FooterSmall from "./components/principals/FooterSmall";
// Privacidad
import AccessibilityStatement from "./components/legal_terms/Accessibility_statement";
import CookiePolicy from "./components/legal_terms/Cookie_policy";
import LegalNotice from "./components/legal_terms/Legal_notice";
import PrivacyPolicy from "./components/legal_terms/Privacy_policy";

// Admin
import AdminMenu from './components/admin/AdminMenu';
import BlogEditor from './components/admin/BlogEditor';
import ServiceEditor from './components/admin/Services/ServiceEditor';
import RequireAuth from './auth/RequireAuth';
import ServiceTypesEditor from './components/admin/Services/ServiceTypesEditor';

// Estilos
import './App.css';
import "./styles.css";
import "./styles/principals/home.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "your-api-key",
  authDomain: "your-auth-domain",
  projectId: "your-project-id",
  storageBucket: "your-storage-bucket",
  messagingSenderId: "your-sender-id",
  appId: "your-app-id"
};

// Initialize Firebase
initializeApp(firebaseConfig);

const App = () => {
  const [contenidoDesplazado, setContenidoDesplazado] = useState(false);

  const handleMenuToggle = (menuOpen) => {
    setContenidoDesplazado(menuOpen);
  };

  return (
    <Router>
      <div className="App">
        <Navbar onMenuToggle={handleMenuToggle} />
        <div className={`main-container ${contenidoDesplazado ? 'shifted' : ''}`}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/about" element={<AboutMe />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogArticle />} />
            <Route path="/login" element={<Login />} />
            <Route element={<RequireAuth />}>
              <Route path="/admin-menu" element={<AdminMenu />} />
              <Route path="/blog-editor" element={<BlogEditor />} />
              <Route path="/service-editor" element={<ServiceEditor />} />
              <Route path="/service-types-editor" element={<ServiceTypesEditor />} />
            </Route>
            <Route path="/accessibilitystatement" element={<AccessibilityStatement />} />
            <Route path="/cookiepolicy" element={<CookiePolicy />} />
            <Route path="/legalnotice" element={<LegalNotice />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          </Routes>
        </div>
        <FooterSmall footerDesplazado={contenidoDesplazado} />
      </div>
    </Router>
  );
};

export default App;
